import React, { useState } from 'react';
import { skills } from '../data/portfolioData';

const C = {
  cyan: '#00f5ff', green: '#00ff88', purple: '#7b2fff',
  gray: '#4a6275', white: '#e8f4f8',
  border: 'rgba(0,245,255,0.12)',
  card: 'rgba(0,245,255,0.025)',
};

export default function Skills() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="skills">
      {/* Header */}
      <div style={{ marginBottom: 60 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          fontFamily: "'Space Mono', monospace", fontSize: 10,
          letterSpacing: 4, textTransform: 'uppercase', color: C.cyan, marginBottom: 12,
        }}>
          <span style={{ width: 32, height: 1, background: C.cyan, display: 'inline-block' }} />
          Expertise
        </div>
        <h2 style={{
          fontFamily: "'Orbitron', monospace",
          fontSize: 'clamp(26px, 4vw, 44px)',
          fontWeight: 700, color: C.white, letterSpacing: -1,
        }}>
          Skills & <span style={{ color: C.cyan }}>Capabilities</span>
        </h2>
      </div>

      {/* Skill cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 20,
      }}>
        {skills.map((skill, i) => {
          const isHov = hovered === i;
          return (
            <div key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: isHov ? 'rgba(0,245,255,0.04)' : C.card,
                border: `1px solid ${isHov ? 'rgba(0,245,255,0.35)' : C.border}`,
                padding: 28,
                transition: 'all .3s ease',
                transform: isHov ? 'translateY(-5px)' : 'translateY(0)',
                boxShadow: isHov ? '0 20px 50px rgba(0,0,0,0.3), 0 0 25px rgba(0,245,255,0.1)' : 'none',
                position: 'relative', overflow: 'hidden',
                cursor: 'default',
              }}
            >
              {/* Top accent line */}
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0,
                height: 2,
                background: `linear-gradient(90deg, ${C.cyan}, transparent)`,
                transform: isHov ? 'scaleX(1)' : 'scaleX(0)',
                transformOrigin: 'left',
                transition: 'transform .4s ease',
              }} />

              {/* Corner decoration */}
              <div style={{
                position: 'absolute', bottom: 0, right: 0,
                width: 50, height: 50,
                borderTop: `1px solid ${isHov ? 'rgba(0,245,255,0.2)' : 'transparent'}`,
                borderLeft: `1px solid ${isHov ? 'rgba(0,245,255,0.2)' : 'transparent'}`,
                transition: 'all .3s',
              }} />

              <div style={{ fontSize: 30, marginBottom: 14 }}>{skill.icon}</div>
              <div style={{
                fontFamily: "'Orbitron', monospace",
                fontSize: 13, fontWeight: 600, color: C.white,
                letterSpacing: 1, marginBottom: 10,
              }}>
                {skill.name}
              </div>
              <p style={{
                fontSize: 13.5, color: C.gray, lineHeight: 1.75, marginBottom: 18,
              }}>
                {skill.desc}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {skill.tags.map((tag, j) => (
                  <span key={j} style={{
                    fontFamily: "'Space Mono', monospace",
                    fontSize: 9, letterSpacing: 1.5,
                    padding: '3px 10px',
                    border: `1px solid rgba(0,245,255,${isHov ? '0.3' : '0.15'})`,
                    color: isHov ? C.cyan : C.gray,
                    textTransform: 'uppercase',
                    transition: 'all .3s',
                  }}>{tag}</span>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {/* Tech bar */}
      <div style={{
        marginTop: 60,
        padding: '24px 32px',
        background: C.card,
        border: `1px solid ${C.border}`,
        display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
      }}>
        <span style={{
          fontFamily: "'Space Mono', monospace", fontSize: 9,
          letterSpacing: 3, color: C.cyan, textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}>
          Tech Stack //
        </span>
        {[
          'Python', 'TensorFlow', 'React', 'Laravel', 'PHP', 'JavaScript',
          'HTML/CSS', 'MySQL', 'Git', 'Figma', 'Canva', 'Microsoft Office',
        ].map((t, i) => (
          <span key={i} style={{
            fontFamily: "'Space Mono', monospace",
            fontSize: 10, letterSpacing: 1,
            color: 'rgba(232,244,248,0.5)',
            transition: 'color .2s',
            cursor: 'default',
          }}
            onMouseEnter={e => e.target.style.color = C.cyan}
            onMouseLeave={e => e.target.style.color = 'rgba(232,244,248,0.5)'}
          >
            {t}
          </span>
        ))}
      </div>
    </section>
  );
}
